// Mock Content Data
// Extracted from ContentCreation.tsx

export interface ContentItem {
  id: string;
  title: string;
  type: 'article' | 'video' | 'course' | 'workshop' | 'live_stream' | 'podcast';
  status: 'draft' | 'published' | 'scheduled' | 'archived';
  description: string;
  tags: string[];
  category: string;
  publishDate?: string;
  views: number;
  likes: number;
  comments: number;
  revenue: number;
  duration?: string;
  thumbnail?: string;
  content?: string;
  price?: number;
  isPremium: boolean;
  createdAt: string;
  updatedAt: string;
}

export const mockContent: ContentItem[] = [
  {
    id: '1',
    title: 'Diabetes Management: A Complete Guide',
    type: 'course',
    status: 'published',
    description: 'Comprehensive course covering diabetes management strategies, nutrition, and lifestyle changes.',
    tags: ['diabetes', 'nutrition', 'lifestyle'],
    category: 'Chronic Conditions',
    publishDate: '2025-01-15',
    views: 1247,
    likes: 89,
    comments: 23,
    revenue: 1250.00,
    duration: '2h 30m',
    price: 49.99,
    isPremium: true,
    createdAt: '2025-01-10',
    updatedAt: '2025-01-15'
  },
  {
    id: '2',
    title: 'Quick Healthy Breakfast Ideas',
    type: 'video',
    status: 'published',
    description: '5-minute video showing quick and healthy breakfast options for busy mornings.',
    tags: ['breakfast', 'healthy', 'quick'],
    category: 'Nutrition',
    publishDate: '2025-01-12',
    views: 892,
    likes: 67,
    comments: 12,
    revenue: 0,
    duration: '5m 23s',
    price: 0,
    isPremium: false,
    createdAt: '2025-01-10',
    updatedAt: '2025-01-12'
  },
  {
    id: '3',
    title: 'Stress Management Techniques',
    type: 'article',
    status: 'draft',
    description: 'Evidence-based stress management techniques for better mental health.',
    tags: ['stress', 'mental-health', 'wellness'],
    category: 'Mental Health',
    views: 0,
    likes: 0,
    comments: 0,
    revenue: 0,
    price: 0,
    isPremium: false,
    createdAt: '2025-01-18',
    updatedAt: '2025-01-18'
  },
  {
    id: '4',
    title: 'Mediterranean Diet Basics',
    type: 'article',
    status: 'published',
    description: 'Introduction to the Mediterranean diet and its health benefits.',
    tags: ['mediterranean', 'diet', 'nutrition'],
    category: 'Nutrition',
    publishDate: '2025-01-14',
    views: 567,
    likes: 34,
    comments: 8,
    revenue: 0,
    price: 0,
    isPremium: false,
    createdAt: '2025-01-12',
    updatedAt: '2025-01-14'
  },
  {
    id: '5',
    title: 'Home Workout for Beginners',
    type: 'video',
    status: 'published',
    description: 'Complete 20-minute home workout routine for fitness beginners.',
    tags: ['workout', 'fitness', 'beginners'],
    category: 'Fitness',
    publishDate: '2025-01-16',
    views: 734,
    likes: 45,
    comments: 15,
    revenue: 0,
    duration: '20m 15s',
    price: 0,
    isPremium: false,
    createdAt: '2025-01-14',
    updatedAt: '2025-01-16'
  }
]; 